import { Theme, makeStyles } from '@material-ui/core';

interface UsePublicWrapperStylesProps {
  bannerImgUrlRectangle: string;
  bannerImgUrlRectangleRocket: string;
  bannerSubmit: string;
  bannerNext: string;
  bannerEclipse: string;
  buttonLogout: string;
  bannerImgUrlWomanWorkingOnlaptop: string;
  displaySecondaryOnMobile?: boolean;
  bannerImageHeight: number;
}

const usePublicWrapperStyles = makeStyles<Theme, UsePublicWrapperStylesProps>((theme) => {
  const mobileBreakpoint = theme.breakpoints.down('sm');
  const maxImgHeight =  'calc(48vh - 50px)';
  return ({
    container: {
      height: '100vh',
      [mobileBreakpoint]: {
        display: 'flex',
        flexDirection: 'column'
      }
    },
    whiteBg: {
      backgroundColor: 'var(--white)',
    },
    buttonGroup: {
      marginTop: '46px'
    },
    imgBackground: {
      position: 'absolute',
      zIndex: 0,
      height: '100%',
      '&>img': {
        height: '100%',
        width: '100%'
      },
      left: '61%',
      [mobileBreakpoint]: {
        display: 'none',
        left: 0,
        top: '25%',
        maxWidth: '100%',
        overflow: 'hidden'
      },
    },
    root: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      maxWidth: '100%',
      //width: '1440px',
      margin: 'auto',
      zoom: '85%',
      [mobileBreakpoint]: {
        display: 'block',
        margin: 'initial'
      },
    },
    contentColumn: {
      display: 'flex',
      flexDirection: 'column',
      flexBasis: '75%',
      flex: '1',
      width: '40%',
      marginTop: '-14px',
      [mobileBreakpoint]: {
        height: 'auto',
        width: 'auto'
      }
    },
    imageColumn: {
      display: 'flex',
      flexDirection: 'column',
      //flexBasis: '115%',
      //flex: '1',
      width: '100%',
      maxHeight: '900px',
      [mobileBreakpoint]: {
        width: '100%',
        maxHeight: maxImgHeight,
      }
    },
    imageColumnBg: {
      display: 'none',
      [mobileBreakpoint]: {
        display: 'block',
        width: '100%',
        maxHeight: maxImgHeight,
        position: 'absolute',
      }
    },
    workingWomanImg: {
      padding: '109px 60px 0 0',
      marginLeft: '60px',
      zIndex: 1,
      [mobileBreakpoint]: {
        maxWidth: '100%',
        maxHeight: maxImgHeight,
        padding: '16px'
      }
    },
    usPageBannerContainer: {
      marginTop: '40px',
      padding: '0px 0px 0px 88px',
      [mobileBreakpoint]: {
        padding: '0px 24px 24px 24px',
        marginTop: '0px',
      }
    },
    bannerContainer: {
      padding: '0px 0px 0px 46px',
      [mobileBreakpoint]: {
        padding: '0px 24px 24px 24px'
      }
    },
    bannerTitle: {
      fontFamily: 'var(--font-family-base)',
      fontSize: 'var(--logPage-header-text-size)',
      lineHeight: '68px',
      color: 'var(--black)',
      marginTop: '0rem',
      marginBottom: '0.5rem',
    },
    header: {
      padding: '48px 0px 48px 48px',
      [mobileBreakpoint]: {
        padding: '24px 0px 24px 24px'
      }
    },
    marginUp: {
      marginTop: '40px'
    },
    logo: {
      width: '200px',
      height: 'auto'
    },
    secondaryContent: {
      fontSize: '24px',
      lineHeight: '34px',
      fontFamily: 'var(--font-family-base)',
      color: 'var(--black)',
      marginBottom: '2.5rem'
    },
    footerNonMobile: {
      position: 'fixed',
      bottom: '40px', 
      [mobileBreakpoint]: {
        display: 'none'
      }
    },
    footerMobile: {
      display: 'none',
      [mobileBreakpoint]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 50,
      }
    },
    applicationBox: {
      padding: '40px', gap: '12px',
      position:'absolute',
      width: '449px',
      height: '316px',
      left: '60%',
      top: '30%',
      background:'#FFFFFF',
      boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.15), 0px 1px 10px rgba(0, 0, 0, 0.15), 0px 2px 4px rgba(0, 0, 0, 0.15)',
      borderRadius: '4px',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '900px',
      [mobileBreakpoint]: {
      width: '100%',
      maxHeight: maxImgHeight,
      }
    },

    bannerComplete: {
      height: '28px', 
      fontSize: '20px',
    }
  });
});

export default usePublicWrapperStyles;
